import React, { FC } from 'react';
import {
  Label,
  useFiltersLabel,
  getOptionsWithEmptyOption,
  FiltersNameEnum,
  SelectOption,
  FilterDrawerType,
} from '@blocs.filter';
import { RangeSelector } from '../../../shared/components';
import { StyledFormikSelect } from '../../../shared/styles';
import { RangeList, RangeItem } from '../ClothingSizesStyles';

type Props = {
  showInImperial: boolean;
  type: FilterDrawerType;
  optionsList: { [key: string]: SelectOption[] };
};

const ClothingSizesMen: FC<Props> = ({ showInImperial, type, optionsList }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);
  const {
    chestOptions,
    necksOptions,
    sleevesOptions,
    coatsOptions,
    maleTshirtSizesOptions,
    maleShoeSizeOptions,
    shoeModifierOptions,
  } = optionsList;

  return (
    <RangeList>
      <RangeItem>
        <RangeSelector
          saveAsOption
          showInImperial={showInImperial}
          rangeName={FiltersNameEnum.chest}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.chest]}
          options={chestOptions}
        />
      </RangeItem>
      <RangeItem>
        <RangeSelector
          saveAsOption
          showInImperial={showInImperial}
          rangeName={FiltersNameEnum.neck}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.neck]}
          options={necksOptions}
        />
      </RangeItem>
      <RangeItem>
        <RangeSelector
          saveAsOption
          showInImperial={showInImperial}
          rangeName={FiltersNameEnum.sleeve}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.sleeve]}
          options={sleevesOptions}
        />
      </RangeItem>
      <RangeItem>
        <RangeSelector
          saveAsOption
          rangeName={FiltersNameEnum.coat}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.coat]}
          options={coatsOptions}
        />
      </RangeItem>
      <RangeItem>
        <RangeSelector
          saveAsOption
          rangeName={FiltersNameEnum.menTShirt}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.menTShirt]}
          options={maleTshirtSizesOptions}
        />
      </RangeItem>
      <RangeItem>
        <RangeSelector
          saveAsOption
          rangeName={FiltersNameEnum.menShoes}
          maxName={FiltersNameEnum.max}
          minName={FiltersNameEnum.min}
          label={filtersLabelOfAudience[FiltersNameEnum.menShoes]}
          options={maleShoeSizeOptions}
        />
      </RangeItem>
      <RangeItem>
        <Label>{filtersLabelOfAudience[FiltersNameEnum.menShoeWidth]}</Label>
        <StyledFormikSelect
          saveAsOption
          name={FiltersNameEnum.menShoeWidth}
          size="small"
          options={getOptionsWithEmptyOption(shoeModifierOptions)}
        />
      </RangeItem>
    </RangeList>
  );
};

export default ClothingSizesMen;
